<div class="main-container background">
  <div *ngIf="subscriptionTypeGdo == 'gdo'" class="webview box">

    <div *ngIf="!currentPlanExpired && currentPlanDuration == 'Trial' && !upcomingPackageAvailable"
      class="current_package-container">
      <div class="pb-2">
        <div class="pdl-1 header-section">
          <p class="pd-l-1 header-info">myQ Connected Garage</p>
        </div>
        <div class="pd-l-1 package-section">
          <p> Complimentary {{ currentPlanDuration}}</p>
          <p *ngIf="!refundRequestPending"> Expires on: {{ currentPlanInfo.endDate | date: 'MM/dd/yyyy' }}</p>
          <p *ngIf="refundRequestPending"
            class="line-height-15 font-12 text-color text-center-align text-red text-left-align">
            Cancellation in progress...
          </p>
        </div>
        <!-- remove this div once testing for flow is completed before production -->
        <div class="change-subs-fecture-btns flex justify-content-center">
          <button class="standard-btn subs-button btn-width" mat-flat-button
            (click)="onChangeSubscriptionClick()">{{refundRequestPending?'Renew Subscription':'Purchase
            Subscription'}}</button>
          <button class="edit-form-button button-content btn-width" mat-flat-button
            (click)="onCancelSubscriptionClicked()">Cancel Trial</button>
        </div>
        <!--  -->
      </div>
    </div>

    <!-- second subsection:This section will handle both cases where is current is trial or a paid annual_OR_monthly plan-->
    <div
      *ngIf="!currentPlanExpired && (currentPlanDuration == 'Trial'|| currentPlanDuration == '5 Year' || currentPlanDuration == '3 Year') && upcomingPackageAvailable">

      <!-- top section -->
      <div class="pd-l-1">
        <span class="section-info">Current</span>
        <div class="header-section">
          <p class="header-info">myQ Connected Garage</p>
          <p class="header-info"><span *ngIf="currentPlanDuration != 'Trial'">{{ currentPlanRatePerUnit
              |currency}}</span></p>
        </div>
        <div class="package-section">
          <p> {{ currentPlanDuration }} Subscription</p>
          <p> Expires on: {{ currentPlanInfo.endDate | date: 'MM/dd/yyyy' }}</p>
        </div>
      </div>

      <!-- bottom section -->
      <hr class="border-bottom" />
      <div class="">
        <span class="pd-l-1 section-info">Upcoming</span>
        <div class="pd-l-1 header-section">
          <p class="header-info">myQ Connected Garage</p>
          <p class="header-info"><span>{{ upcomingPlanRatePerUnit |currency}}</span></p>
        </div>
        <div class="pd-l-1 package-section">
          <p> {{ upcomingPlanInfo.planName }}</p>
          <p> Starts on {{ startDateForUI }}</p>
        </div>


        <div class="pd-t-1 change-subs-fecture-btns flex justify-content-center">
          <button class="edit-form-button button-content btn-width" mat-flat-button
            (click)="onCancelSubscriptionClicked()">Cancel Subscription</button>
        </div>
      </div>
    </div>


    <!--third subsection :this section contains all three use cases for cancel renew and expire-->
    <div
      *ngIf="!currentPlanExpired && (currentPlanDuration == '5 Year' || currentPlanDuration == '3 Year') && !upcomingPackageAvailable">

      <div class="pd-l-1 header-section margin-top-10px">
        <p class="header-info">myQ Connected Garage</p>
        <p class="header-info"><span>{{ currentPlanRatePerUnit | currency}}</span></p>
      </div>
      <div class="pd-l-1 package-section">
        <p> {{ currentPlanDuration }} Subscription</p>
        <p *ngIf="!refundRequestPending"> Expires on: {{currentPlanInfo.endDate | date: 'MM/dd/yyyy'}}</p>
        <p *ngIf="refundRequestPending"
          class="line-height-15 font-12 text-color text-center-align text-red text-left-align">
          Cancellation in progress...
        </p>
      </div>

      <!-- main condition to check -->
      <div *ngIf="!currentPlanExpired && (currentPlanStatus != 'Cancelled'|| currentPlanStatus !== 'Terminated')">

        <!-- now check for cancellable  -->
        <div *ngIf="!currentPlanRenewable && currentPlanCancelable">
          <div class="change-subs-fecture-btns flex justify-content-center"> <button
              class="standard-btn subs-button btn-width" mat-flat-button (click)="onCancelSubscriptionClicked()">Cancel
              Subscription</button></div>
          <div>
            <p class="text-renewal-details line-height-15 font-12 text-color font-weight-400 text-center-align"> If you
              cancel your subscription, no refund will be provided.</p>
          </div>
        </div>

        <!-- now check for renewable  -->
        <div *ngIf="currentPlanRenewable ">
          <div class="change-subs-fecture-btns flex justify-content-center">
            <button class="edit-form-button subs-button btn-width" mat-flat-button
              (click)="onChangeSubscriptionClick()">Renew Subscription</button>
            <button class="edit-form-button button-content btn-width" mat-flat-button
              (click)="onCancelSubscriptionClicked()">Cancel Subscription</button>
          </div>
        </div>
      </div>
    </div>



    <!-- when current plan is expired or cancelled show this 
    - this case will run when trial, or paid 3/5 year is cancelled or expired
    -->
    <div
      *ngIf="currentPlanExpired || currentPlanStatus == 'Cancelled' || currentPlanStatus == 'Expired' || currentPlanStatus == 'Terminated' ">
      <div class="pb-2">
        <div class="pdl-1 header-section">
          <p class="pd-l-1 header-info">myQ Connected Garage</p>
        </div>
        <div class="pd-l-1 package-section">
          <p>
            <span *ngIf="currentPlanDuration !== 'Trial'">{{ currentPlanDuration}} Subscription </span>
            <span *ngIf="currentPlanDuration === 'Trial'">Complimentary {{ currentPlanDuration}} </span>
          </p>

          <p *ngIf="currentPlanStatus == 'Cancelled' || currentPlanStatus == 'Expired'"
            [style.color]="isAcura ? '#FFFFFF' : '#000000'">
            {{currentPlanStatus}} on {{currentPlanStatusDate | date:'MM/dd/yyyy'}}
          </p>

          <p *ngIf="refundRequestPending"
            class="line-height-15 font-12 text-color text-center-align text-red text-left-align">
            Cancellation in progress...
          </p>

          <p *ngIf="currentPlanStatus == 'Terminated' && !refundRequestPending">
            Expired on {{currentPlanStatusDate | date : 'MM/dd/yyyy' }}
          </p>
        </div>

        <div class="change-subs-fecture-btns flex justify-content-center">
          <button class="standard-btn subs-button btn-width" mat-flat-button
            (click)="onChangeSubscriptionClick()">{{refundRequestPending?'Renew Subscription':'Purchase
            Subscription'}}</button>
          <!-- <button class="edit-form-button button-content btn-width" mat-flat-button (click)="onCancelSubscriptionClicked()">Cancel Subscription</button> -->
        </div>
        <div>
          <p class="text-renewal-details line-height-15 font-12 text-color font-weight-400 text-center-align">
            Your subscription has been {{currentPlanStatus}}.<br />Subscribe above to active the service.
          </p>
        </div>
      </div>
    </div>






  </div>

  <!-- Features Section start-->
  <!-- Billing -->
  <div class="webview box">
    <div class="container-detail unset-minheight">
      <div>
        <p class="font-14 text-color font-weight-500 padding-top-10">
          Billing History
        </p>
      </div>
      <button mat-flat-button (click)="onViewBillingHistoryClick()" class="button-wv">
        View
      </button>
    </div>

    <div class="row border-bottom">
      <p class="
        font-12 text-color font-weight-400 zero-padding">
        Last Billed On:
        {{
        (!currentPlanExpired && currentPlanDuration === 'Trial') ||
        currentPlanStatus === 'Cancelled'
        ? 'N/A'
        : currentPlanInfo.lastBillDate
        }}
      </p>
    </div>

    <!-- Payment Method -->
    <div class="container-detail">
      <div>
        <p class="font-14 text-color font-weight-500 padding-top-10">
          Payment Method
        </p>
        <div>
          <p id="p3" class="font-14 text-color font-weight-400 zero-padding">
            {{paymentMethodInfo && paymentMethodInfo.suffix ? paymentMethodInfo.ccType + ' **** **** ****' +
            paymentMethodInfo.suffix :'' }}
          </p>
          <p id="p4" class="font-14 text-color billing-text font-weight-400 zero-padding">
            Billing Address: {{billingAddress ? billingAddress : 'Not configured'}}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- Subscription contact information -->
  <div class="webview box">
    <div class="container-detail">
      <div>
        <p class="font-14 text-color font-weight-500 padding-top-10">
          Subscriber Contact Information
        </p>
      </div>
      <button mat-flat-button (click)="onEditSubscriptionInfo()" class="button-wv" [disabled]="stolenStatus">
        Edit
      </button>
    </div>
    <div class="row">
      <div class="col-6 col-sm-3">
        <p class="font-12 text-color font-weight-500">Name</p>
        <p class="font-12 text-color font-weight-400">
          {{ acctDetail && acctDetail.firstName + " " + acctDetail.lastName }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-12 text-color font-weight-500">Primary Phone Number</p>
        <p class="font-12 text-color font-weight-400">
          {{ primaryPhoneNumber }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-12 text-color font-weight-500">Email</p>
        <p class="font-12 text-color font-weight-400 break-word">
          {{ acctDetail && acctDetail.email }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-12 text-color font-weight-500">Secondary Phone Number</p>
        <p class="font-12 text-color font-weight-400">
          {{ cellPhoneNumber }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-12 text-color font-weight-500">Address</p>
        <p class="font-12 text-color font-weight-400 break-word">
          {{ street }} {{ city }} {{ country }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-12 text-color font-weight-500">Preferred Language</p>
        <p class="font-12 text-color font-weight-400">{{prefLanguage}}</p>
      </div>
      <div class="col-sm-6"></div>
    </div>
    <!--Connected Garage Features -->

  </div>

  <!-- Introduction Video -->
  <div class="webview box">
    <div class="container-detail border-bottom">
      <div>
        <p class="font-14 text-color font-weight-500 padding-top-10">
          myQ Connected Garage Features
        </p>
      </div>
      <button mat-flat-button class="button-wv" (click)="onViewmyQConnectedGarageFeatureClick()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
    <div class="container-detail border-bottom">
      <div>
        <p class="font-14 text-color font-weight-500 padding-top-10 margin-bottom-0">
          myQ Connected Garage
        </p>
        <p class="font-14 text-color font-weight-500 zero-padding">
          Introduction Video
        </p>
      </div>
      <button mat-flat-button class="button-wv" (click)="onViewmyQConnectedGarageDemoClick()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>

    <!-- Terms of Use -->
    <div class="container-detail">
      <div>
        <p class="font-14 text-color font-weight-500 padding-top-10 margin-bottom-0">
          myQ Connected Garage
        </p>
        <p id="p1" class="font-14 text-color font-weight-500 zero-padding">
          Terms of Use
        </p>
        <p id="p2" class="font-12 text-color font-weight-400">
          <!-- CPSCFI23M-1826 -->
          Last Updated: 01/23/2023
          <!-- {{currentPlanInfo.startDate}} -->
        </p>
      </div>
      <button mat-flat-button class="button-wv" (click)="onViewTermsOfServiceClick()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>

  <!-- Footer Detail -->
  <div class="webview box">
    <div class="container-detail">
      <div class="container-faqs padding-top-10">
        <p class="font-14 text-color font-weight-500">
          Need Help?
        </p>
        <a class="font-12 {{isAcura ? 'dark-theme-color' : 'light-theme-color'}} zero-padding font-weight-500"
          href="tel:+18885287876">+1 (888) 528-7876</a>
        <p class="font-12 text-color zero-padding">
          Monday - Friday
          <br>
          6:00 AM - 5:00 PM PST
        </p>
        <div class="border-bottom"></div>
        <div class="container-faqs-detail">
          <p class="font-14 text-color font-weight-500 padding-top-10">
            myQ Connected Garage FAQs
          </p>
          <button mat-flat-button class="button-wv" (click)="onLinkClick()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Features Section end-->
</div>